import { gql } from "graphql-request";

export const notificationsQuery = gql`
    query ($locale: SiteLocale!, $marketId: [ItemId]!) {
  allNotificationsModels(locale: $locale, fallbackLocales: [en], filter: {
    enabledLocales: { eq: true }
    enabledMarkets: {
      anyIn: $marketId
    }
  }) {
      id
      externalUrl
      notificationMessage
      relativePath
      enabledMarkets {
          countryIsoCode
      }
      enabledLocales
      accessibleText
      content {
          ... on CustomerModelRecord {
            customerSlug: slug
          }
          ... on PageModelRecord {
            slug
          }
          ... on ArticleModelRecord {
            blogSlug: slug
          }
          ... on IntegrationModelRecord {
            integrationSlug: slug
          }
      }
    }
  }
`